import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { useAuth } from 'components/auth'
import { Spinner } from 'lp-components'
import { selectors } from '../reducer'
import * as actions from '../actions'
import * as apiActions from 'api-actions'
import { AllMembershipsType } from 'types'
import { makeMemberPortalPath, PATH, getAccountIdentifier } from 'config'
import { getPrimaryMembership, withApiAuth } from 'utils'

const propTypes = {
  allMemberships: AllMembershipsType,
  children: PropTypes.node.isRequired,
  clearAllMemberships: PropTypes.func.isRequired,
  fetchAllMembershipsForAccount: PropTypes.func.isRequired,
  updateMembershipAssociatedAccount: PropTypes.func.isRequired,
}

function AllMembershipsProvider({
  allMemberships,
  children,
  clearAllMemberships,
  fetchAllMembershipsForAccount,
  updateMembershipAssociatedAccount,
}) {
  const history = useHistory()

  const { user } = useAuth()
  const memberAccountId = getAccountIdentifier(user)
  const { membershipNumber } = getPrimaryMembership(allMemberships)

  useEffect(() => {
    const fetchMemberships = async () => {
      try {
        await fetchAllMembershipsForAccount(memberAccountId)
      } catch (error) {
        history.push(makeMemberPortalPath(PATH.MEMBER_APPLICATION))
      }
    }
    fetchMemberships()

    return () => clearAllMemberships()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [memberAccountId])

  // Once the membership data is available, reassociate the member's Auth0 
  // account with their membership record. This ensures that the member's 
  // account data is correctly associated with their membership.
  useEffect(() => {
    if (membershipNumber && user) {
      updateMembershipAssociatedAccount(user.email, membershipNumber)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [membershipNumber, user])

  if (!allMemberships) return <Spinner />

  return children
}

AllMembershipsProvider.propTypes = propTypes

function mapStateToProps(state) {
  return {
    allMemberships: selectors.allMemberships(state),
  }
}

const mapDispatchToProps = {
  clearAllMemberships: actions.clearAllMemberships,
  updateMembershipAssociatedAccount:
    apiActions.updateMembershipAssociatedAccount,
}

const mapApiAuthToProps = {
  fetchAllMembershipsForAccount: apiActions.fetchAllMembershipsForAccount,
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withApiAuth(mapApiAuthToProps),
)(AllMembershipsProvider)
